import { gql } from 'graphql-tag';
import { fieldArguments } from './resourceAllocationFieldSelection';
import specificResourceAllocationFragment from './specificResourceAllocationFragment';
import { specificResourceAllocationUser2Fragment } from './specificResourceAllocationUserFragment';

export const RESOURCE_ALLOCATIONS_QUERY = gql`
  query BulkGetResourceAllocations(
    $filter: ResourceAllocationFilter
    ${fieldArguments}
  ) {
    resourceAllocations(filter: $filter) {
      resourceAllocations {
        ...SpecificResourceAllocation
        user {
          ...SpecificResourceAllocationUser2
        }
        role {
          uri
          id
          displayText
          currentRate @include(if: $includeRoleCurrentRate) {
            amount
            currency {
              id
              displayText
            }
          }
        }
        project @include(if: $includeProject) {
          id
          startDate
          endDate
          name
          displayText
          permittedActionUris
          defaultScheduleRule {
            dateRange {
              startDate
              endDate
            }
            do
          }
        }
      }
      nextPageCursor
    }
  }
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUser2Fragment}
`;

export const tryLoadCachedAllocationQuery = ({ proxy, variables }) => {
  try {
    return proxy.readQuery({
      query: RESOURCE_ALLOCATIONS_QUERY,
      variables
    });
  } catch (e) {
    return null;
  }
};
